import './useAutofillEvent.css';
export var autofillBackground = 'var(--_yfwka30-3-5-0)';
export var autofillCSS = '_yfwka33-3-5-0';
export var end = '_yfwka32-3-5-0';
export var start = '_yfwka31-3-5-0';